import globals from "@homer.core/globals";
import page from "@homer.core/page";

const url = URL.resolve(location.href);
const id = url.parameter?.newsletter?.confirm?.id;
const hash = url.parameter?.newsletter?.confirm?.hash;

if (id && hash) {
    url.searchParams.delete("newsletter[confirm][id]");
    url.searchParams.delete("newsletter[confirm][hash]");
    page.replace(url.href);

    void globals.demand.request("@apfelkiste/subscription.newsletter").then(([NewsletterSubscription]) => {
        return NewsletterSubscription.confirm({ id, hash });
    });
}
